import AuthLayoutSubmitButton from "../../components/shared-components/buttons/AuthLayoutSubmitButton";
import styles from "./SignIn.module.css";
import { useNavigate } from "react-router-dom";
import {useForm} from 'react-hook-form'
import EmailInputField from "../../components/shared-components/input-field/EmailInputField";
import PasswordInputField from "../../components/shared-components/input-field/PasswordInputField";
import ToasterWithMessage from '../../components/shared-components/toaster/index'
import { useContext, useState } from "react";
import { CircularProgress } from "@mui/material";
import {signIn} from 'aws-amplify/auth'
import { useLazyQuery } from "@apollo/client";
import { GET_USER_ROLE } from "./api/SignInQuery";
import { globalContext } from "../../Provider/AppProvider";
import { roles, getRoleFromDomain, isRoleAllowed, resolvePreferredPortalRole } from "../../helper";
import { getMyRolePageAccess } from "../../services/rolePageAccessApi";
import {
  getRoleDefaultPageKeys,
  isPageAccessControlledRole,
  resolveDefaultPathFromPageKeys,
  withPersonalPageKeys,
} from "../../constants/pageAccess";

interface SignInSubmitData {
  email: string,
  password: string
}
const SignIn= () => {
  const {error}= ToasterWithMessage();
  const roleFromDomain = getRoleFromDomain();
  const [callSignInData,setCallSignInData] = useState<SignInSubmitData>();
  const [loading, setLoading] = useState(false);
  const [disableBtn,setDisableBtn]= useState(false);
  const {register,handleSubmit,reset,formState: {errors}} = useForm({defaultValues: {email:"",password: ""},mode: "onTouched"});
  const navigate = useNavigate();
  const {globalState,handleGlobalState} = useContext<any>(globalContext);

  // navigating to the forgot password page
  const handleClickForgotPassword = () => {
    navigate("/forgot-password");
  };

  const [getUserRole] = useLazyQuery(GET_USER_ROLE,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data && data?.user.length !== 0){
        const allowedRoles = data?.user?.[0]?.u_allowed_roles || [];
        const role =
          resolvePreferredPortalRole(allowedRoles, data?.user?.[0]?.u_role) ||
          data?.user?.[0]?.u_role;
        if(callSignInData){
          if (role === roles.SUPER_USER && roleFromDomain !== roles.SUPER_USER) {
            setLoading(false);
            setDisableBtn(false);
            error("Self Pricing User should sign in only on user.quickasyst.com");
            return;
          }
          if(isRoleAllowed(role,roleFromDomain)){
            CognitoSignIn(callSignInData,role);
          }else{
            setLoading(false);
            setDisableBtn(false);
            error("You don't have permission to access this page");
          }
        }else{
          setLoading(false);
          setDisableBtn(false);
          error("User does not exist.");
        }
      }else {
        setLoading(false);
        setDisableBtn(false);
        error("User does not exist.");
      }
    },
    onError: () => {
      setLoading(false);
      setDisableBtn(false);
      error("Something went wrong while fetching user role!");
    }
  });

  const handleSubmitData = async (data: SignInSubmitData)=>{
    setLoading(true)
    if(errors.email || errors.password){
      setDisableBtn(false);
    }else{
      setDisableBtn(true);
    }
    setCallSignInData(data);
    getUserRole({variables: {emailId: data?.email}});
  }

  const getDefaultPathByRole = (role: string) => {
    if(role===roles.ADMIN || role===roles.AFFILIATER_ADMIN || role===roles.SUB_ADMIN || role===roles.SUPER_USER){
      return "/dashboard";
    }
    if(role===roles.MARKETING_USER){
      return "/users";
    }
    if(role==="logitix_user"){
      return "/tickets";
    }
    return "/login";
  };

  const CognitoSignIn = async (data: SignInSubmitData,role:string) => {
    try {
      const dataResponse = await signIn({username: data.email,password: data.password});
      if(dataResponse?.isSignedIn){                
        const resolvedRole = role;
        localStorage.setItem("x-hasura-user-role", resolvedRole);
        reset({email: "",password: ""});

        const tempState={...globalState};
        tempState.profile.userRole=resolvedRole;

        let landingPath = getDefaultPathByRole(resolvedRole);
        if (isPageAccessControlledRole(resolvedRole)) {
          try {
            const pageAccessResponse = await getMyRolePageAccess(resolvedRole);
            const assignedPageKeys = withPersonalPageKeys(pageAccessResponse?.pageKeys || []);
            tempState.profile.allowedPageKeys = assignedPageKeys;
            tempState.profile.pageAccessLoaded = true;
            localStorage.setItem("qa-role-page-access", JSON.stringify(assignedPageKeys));
            landingPath = resolveDefaultPathFromPageKeys(resolvedRole, assignedPageKeys);
          } catch (_err: any) {
            const fallbackPageKeys = withPersonalPageKeys(getRoleDefaultPageKeys(resolvedRole));
            tempState.profile.allowedPageKeys = fallbackPageKeys;
            tempState.profile.pageAccessLoaded = true;
            localStorage.setItem("qa-role-page-access", JSON.stringify(fallbackPageKeys));
            landingPath = resolveDefaultPathFromPageKeys(resolvedRole, fallbackPageKeys);
          }
        } else {
          tempState.profile.allowedPageKeys = [];
          tempState.profile.pageAccessLoaded = false;
          localStorage.removeItem("qa-role-page-access");
        }

        handleGlobalState({...tempState,tempState});
        if (landingPath === "/login") {
          error("You don't have permission to access this page");
        }
        navigate(landingPath);
        setLoading(false);
      }
   } catch (errors) {
     setDisableBtn(false);
     setLoading(false);
     error((errors as any)?.message || 'Something went wrong!');
   }
  }

  return (
    <>
    <form onSubmit={handleSubmit(handleSubmitData)} autoComplete="off">
      <div className={loading ? styles.loadSignInForm : styles.signInForm}>
      <div className={styles.textField}>
        <div className={styles.textFieldFullMain}>
          <div className={styles.titlePlaceholder}>
            <div className={styles.email}>Email</div>
          </div>
         <EmailInputField disabled={false} errors={errors} register={register} moduleName={"signin"}/>
        </div>
        <div className={styles.textFieldFullMain1}>
          <div className={styles.titlePlaceholder1}>
            <div className={styles.email}>Password</div>
          </div>
         <PasswordInputField errors={errors} register={register} skipComplexityValidation />
        </div>
      
          <div className={styles.forgotPassword} onClick={handleClickForgotPassword}>Forgot Password?</div>
        
      </div>
        {
          loading
        ?
         <div className={styles.signInCircular}>
         <CircularProgress color={"primary"} size={30}/>
         </div>
        : ''
        }
      <AuthLayoutSubmitButton title={"Sign In"} disableBtn={disableBtn}/>
      </div>
    </form>
    </>
  );
};

export default SignIn;
